import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom';
import Broadcast from "../dashboard/Broadcast";

function Home () {
    const [menuData, setMenuData] = useState()
    const dispatch = useDispatch()
    const token = localStorage.getItem('token')
    const menus = useSelector(state => state.navbar.menus)
    const message = useSelector(state => state.navbar.message)
    const {username,mobile,email} = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : []
    return (
        <>
            <Broadcast title='داشبورد' />
            <div className='row justify-content-center align-items-center'>

                <div className='col-12 col-md-3'>
                    
                </div>
                
            </div>
        </>
    )
}

export default Home;